

















import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import SummaryResultApis from '@/mixins/requests/branch/SummaryResultApis.vue'
import { ProblemTagSummaryData } from '@/models/api/common/SummaryResultTypes.vue'
import RatioBar from '@/components/common/atoms/RatioBar.vue'
import ByProblemTagTable from '@/components/branch/organisms/ByProblemTagTable.vue'

@Component({
  components: {
    RatioBar,
    ByProblemTagTable,
  },
})
export default class ByProblemTag extends Mixins(SummaryResultApis) {
  @Prop()
  studyContentId!: string
  @Prop()
  store!: { problemTagSummaryData: ProblemTagSummaryData[] }
  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  @Watch('problemTagSummaryData')
  private onChangeSummaryData() {
    if (this.problemTagSummaryData) {
      this.store.problemTagSummaryData = this.problemTagSummaryData
    }
  }

  private problemTagSummaryData: ProblemTagSummaryData[] = []

  private scoreLabelPush(labelName: string): string {
    return this.isStudyModeRecommend ? labelName + 'スコア' : labelName + '点'
  }

  private async mounted() {
    if (this.store.problemTagSummaryData) {
      this.problemTagSummaryData = this.store.problemTagSummaryData
    } else {
      Vue.prototype.$loading.start()
      try {
        this.problemTagSummaryData = await this.getProblemTagSummary(this.studyContentId)
      } catch (e) {
        if (e.response.data.status === 404) {
          // リクエストのテストIDが存在しない場合は404
          alert('集計情報が存在しません')
        } else if (e.response.data.status === 400) {
          // リクエスト不正
          alert('リクエストが不正です')
        }
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
  }
}
